/** Unicode 码点长度（emoji 计 1，与中文/英文一致） */
export function codePointLength(value: string): number {
  return Array.from(value).length
}

/** 按码点截断，防止粘贴超长文本 */
export function truncateByCodePoints(value: string, max: number): string {
  const chars = Array.from(value)
  return chars.length <= max ? value : chars.slice(0, max).join('')
}

/** 校验/计数前统一 trim */
export function trimForValidate(value: unknown): string {
  return String(value ?? '').trim()
}
